import React from 'react'
import PropTypes from 'prop-types'

const BSInfantNotice = ({ name }) => {
  return (
    <>
      <p>
        <span className="font-weight-bold text-danger">IMPORTANT</span>: {name}{' '}
        are listed by <b>brand name only</b> in WIC Bulletin Regulations (WBR)
        and the CDPH/WIC Shopping Guide. For this Brand Specific RFI, CDPH/WIC
        is soliciting <b>brand information only</b> for this food.
      </p>
      <p>
        <u>Brands not currently authorized</u> should submit{' '}
        <b>only one (1) example product</b> to show that the brand qualifies to
        be included in our upcoming WBR and Shopping Guide revisions. If your
        brand is determined to be qualified, you will be asked to submit
        additional products after the close of the RFI.
      </p>
      <p>
        <u>Currently authorized brands</u> must submit{' '}
        <b>only one (1) product</b> for CDPH/WIC to verify that the brand
        continues to meet authorization criteria.
      </p>
    </>
  )
}

export default BSInfantNotice

BSInfantNotice.propTypes = {
  name: PropTypes.string,
}
